import type { Dayjs } from "dayjs"
import type { TFunction } from "i18next"
import _ from "lodash"

export const normalizeCancellationDeadline = (date: Dayjs) =>
  date.format("HH:mm") === "00:00" ? date.subtract(1, "minute") : date

export const formatCancellationDatetime = (date: Dayjs, t: TFunction) =>
  normalizeCancellationDeadline(date).format(`HH ${_.lowerFirst(t("common.hour"))} DD MMMM`)
